import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import AdminDueDashBoard from "./dashboard";
import Details from "../../pages/inspectionDetails";
import EditInspection from "../../pages/editInspection";
class AdminDasboard extends Component {
  render() {
    let { history } = this.props;
    return (
      <Switch>
        <Route
          exact
          path="/inspection"
          history={history}
          component={AdminDueDashBoard}
        />
        <Route
          exact
          path="/inspection/details/:id"
          history={history}
          component={Details}
        />
        <Route
          exact
          path="/inspection/edit/:id"
          history={history}
          component={EditInspection}
        />
      </Switch>
    );
  }
}

export default AdminDasboard;



// WEBPACK FOOTER //
// ./src/admin/adminDashboard/admindashboardroutes.jsx